import React from 'react'
import SmallCard from '../components/SmallCard'
import '../css/CardRow.css'
import InfiniteScroll from "react-infinite-scroll-component"

class CardRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            hasMore: false,
            pieces: [],
            startnum: 0,
            fetchnum: 50
        };
    }

    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps, prevState)
    {
        // console.log(this.state)
        // console.log(prevProps)
        // console.log(prevState)

        if (this.props.qparms !== prevProps.qparms)
        {
            this.setState({
                startnum: 0,
                hasMore: false,
                pieces: []}, () => this.fetchData())
        }
    }

    fetchData = async(event) => {

        const axios = require('axios')
        let setHasMore = false
        const self = this

        axios.get('https://tota-rarity-data.teamtota.workers.dev/api/listreduce?startnum='+this.state.startnum+'&fetchnum='+this.state.fetchnum+'&'+this.props.qparms)
            .then(function (response) {
                // console.log(response)
                // console.log(self.state)
                if (response.data.length === self.state.fetchnum)
                {
                    setHasMore = true
                }

                self.setState({
                    pieces: self.state.pieces.concat(response.data),
                    startnum: self.state.startnum + self.state.fetchnum,
                    hasMore: setHasMore
                });
            });
    };

    render(){
        return(
            <div className="cardrow">
                 <InfiniteScroll
                  dataLength={this.state.pieces.length}
                  style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}
                  next={this.fetchData}
                  hasMore={this.state.hasMore}
                  loader={<h4>Loading...</h4>}
                  >
                  {this.state.pieces.map((i, index) => (
                        <SmallCard piece={i} key={index} isOpen={this.props.isOpen} setToken={this.props.setToken} />
                  ))}
                </InfiniteScroll>
            </div>
        );
    }
 }
 export default CardRow
 